import { Component, OnInit, HostListener, ViewChild, ElementRef } from "@angular/core";
import { AreaPoligono } from "../building/AreaPoligono";
import { ProyectoService } from "../proyecto/proyecto.service";

@Component({
  selector: "app-layout",
  templateUrl: "./layout.component.html",
  styleUrls: ["./layout.component.scss"],
})
export class LayoutComponent {
  @ViewChild("miImagen", { static: false }) imagenRef!: ElementRef;
  @ViewChild("miCanvas", { static: false }) canvasRef!: ElementRef;

  @ViewChild("imageElement", { static: true })
  imageElementRef!: ElementRef<HTMLImageElement>;
  public floorToView: any = {
    id: 0,
    name: "Dummy Floor",
    url: "assets/layoutPreview.jpg",
  };

  puntos: any;
  puntos_ajustados: any;
  inicio: boolean = false;
  flagLayout: boolean = false;
  layout: any;
  estate: any;

  private canvasEventAdded: boolean = false;
  private ctx!: CanvasRenderingContext2D;
  flag_add_polygon: boolean = false;
  flag_delete_polygon: boolean = false;
  poligonos: AreaPoligono[] = [];

  showDetails = false;

  constructor(private _proyectoService: ProyectoService) {
    console.log("LayoutComponent Constructor", this.floorToView);
  }

  ngOnInit(): void {
    console.log("LayoutComponent ngOnInit");
    this._proyectoService.disparadorDeLayout.subscribe((data: any) => {
      if (data) {
        this.layout = this.floorToView = data;
        this.showDetails = true;
        console.log(this.floorToView);
        this.getLayoutPoints();
        this.onWindowResize(null);
        this.inicio = true;
      } else {
        this.showDetails = false;
        console.log("No se recibió data");
      }
    });
    this._proyectoService.reset.subscribe((data: any) => {
      if (data) {
        console.log("Reset");
        this.showDetails = false;
        this.layout = null;
        this.floorToView = null;
        this.poligonos = [];
        this.inicio = false;
      }
    });
  }

  @HostListener("window:resize", ["$event"])
  onWindowResize(event: any) {
    console.log("onWindowsResize");
    // PUNTOS
    this.onResize();

    // AREAS
    this.createCanvas().then(() => {
      if (this.poligonos.length > 0) {
        this.borrarCanvas();
        this._recalcularCoordenadasPoligonos();
        this._dibujarAreas();
      }
    });
  }

  async getLayoutPoints() {
    try {
      console.log("this.getLayoutPoints()");
      this.puntos = await this._proyectoService.indexUbicationsEstate(
        this.floorToView.id,
        this.floorToView.real_estate_id
      );
      this.puntos = this.puntos.data;
      this.ajustarCoordenadas2();
    } catch (error: any) {
      console.error("Error en getLayoutPoints", error);
    }
  }

  ajustarCoordenadas2() {
    console.log("entro a ajustar coordenadas 2");
    try {
      this.puntos_ajustados = this.puntos?.map((punto: any) => {
        const xx = punto.x / this.layout.width;
        const x = xx * 100;
        const yy = punto.y / this.layout.height;
        const y = yy * 100;

        console.log("x", x, "y", y, "puntos", this.puntos);
        return { ...punto, x, y };
      });
      console.log("puntos ajustados", this.puntos_ajustados);
    } catch (error: any) {
      console.error("Error en ajustarCoordenadas", error.message);
    }
  }

  onResize() {
    console.log("onResize");
    this.ajustarCoordenadas2();
  }

  private onCanvasClick(event: MouseEvent): void {
    console.log("onCanvasClick");
    if (!this.ctx) {
      return;
    }

    if (this.flag_add_polygon) {
      // this.agregarArea(event);
    } else if (this.flag_delete_polygon) {
      // this.eliminarArea(event);
      // this.eliminarArea2(event);
    } else {
      this.checkAreaUpdate(event);
      // this._swal_service.swalInfo('No has seleccionado ninguna acción para realizar en el plano');
    }
  }

  async checkAreaUpdate(event: MouseEvent) {
    let poligono_seleccionado = 0;
    for (let item1 of this.poligonos) {
      const rect = this.canvasRef.nativeElement.getBoundingClientRect();
      const x = event.clientX - rect.left;
      const y = event.clientY - rect.top;

      const value = item1.verificarClick(x, y);
      console.log("eliminarArea2", value);
      if (value) {
        console.log("SELECCIONADO", item1);
        await this.viewData(item1.layout_id);
        console.log("ESTATE", this.estate);
        window.open("detalles/" + this.estate.property.id, "_blank");
        poligono_seleccionado++;
      } else {
        // item1.dibujar(this.ctx);
      }
    }
  }

  async viewData(id: any) {
    console.log("viewData", id);

    try {
      this.estate = await this._proyectoService.getEstateProject(id, this.floorToView.real_estate_id);
      this.estate = this.estate.data;
      console.log("ESTATE", this.estate);
    } catch (error: any) {
      console.error("Error en viewData", error);
    }
  }

  async createCanvas() {
    console.log("createCanvas");
    try {
      console.log(this.imagenRef, this.canvasRef);

      const imagen = this.imagenRef.nativeElement;
      const canvas = this.canvasRef.nativeElement;

      if (!this.canvasEventAdded) {
        this.canvasRef.nativeElement.addEventListener("mousedown", this.onCanvasClick.bind(this));
        this.canvasEventAdded = true;
      }

      this.ctx = canvas.getContext("2d");
      canvas.width = imagen.clientWidth;
      canvas.height = imagen.clientHeight;

      if (this.inicio) {
        await this.indexUbicationsEstateLayout();
      }
    } catch (error: any) {
      console.error("Error en createCanvas", error.message);
    }
  }

  async indexUbicationsEstateLayout() {
    try {
      console.log("indexUbicatinEstateLayout");
      this.indexUbicationsBuildingLayout();
      this.inicio = false;
    } catch (error: any) {
      console.error("Error en indexUbicationsEstateLayout", error);
      this.inicio = false;
    }
  }

  async indexUbicationsBuildingLayout() {
    try {
      console.log("indexUbicatinBuildingLayout");

      this.poligonos = [];
      let poligons: any = await this._proyectoService.indexUbicationsEstate(
        this.floorToView.id,
        this.floorToView.real_estate_id
      );
      console.log("POLIGONS", poligons);
      poligons = poligons.data;
      poligons = Object.values(poligons);
      console.log("VEREMOS_POLIGONOS", poligons);

      for (let pol1 of poligons) {
        let colorFill = "rgba(0, 255, 0, 0.3)";
        pol1 = pol1;
        let vertices = [];
        console.log("POL1", pol1);
        for (let pol2 of pol1) {
          console.log("POL2", pol2);
          if (pol2.estate.available != 1) {
            colorFill = "rgba(255, 0, 0, 0.3)";
          }
          vertices.push({ x: pol2.x, y: pol2.y });
        }
        if (vertices.length > 2) {
          const poligono = new AreaPoligono(vertices, pol1[0].estate.id, "blue", colorFill, this.ctx, this.imagenRef);
          this.poligonos.push(poligono);
        }
      }
      console.log("POLIGONOS terminarDibujoArea", this.poligonos);
      this._dibujarAreas();

      this.inicio = false;
    } catch (error: any) {
      console.log("Error en indexUbicationEstateLayout", error);
      this.inicio = false;
    }
  }

  _dibujarAreas() {
    console.log("ENTRO _dibujarAreas");
    for (let item1 of this.poligonos) {
      item1.dibujar(this.ctx);
    }
  }

  borrarCanvas() {
    this.ctx.clearRect(0, 0, this.canvasRef.nativeElement.width, this.canvasRef.nativeElement.height);
  }

  private _recalcularCoordenadasPoligonos() {
    const canvas = this.canvasRef.nativeElement;
    const escalaX = canvas.width / canvas.clientWidth;
    const escalaY = canvas.height / canvas.clientHeight;

    for (const poligono of this.poligonos) {
      for (const vertice of poligono.vertices) {
        vertice.x *= escalaX;
        vertice.y *= escalaY;
      }
      // Luego, actualiza el Path2D con las nuevas coordenadas
      poligono.actualizarPath(poligono.vertices);
    }
    console.log("POLIGONOS _recalcularCoordenadasPoligonos", this.poligonos);
  }
}
